export const LANGUAGES = {
    'en': 'English',
    'sq': 'Shqip',
    'mk': 'македонски',
    'tr': 'Türkçe',
    'el': 'Ελληνικά',
    'bg': 'Български',
}
export const langMap = {
    'en': 'en-us',
    'sq': 'sq-al',
    'el': 'el-gr',
    'mk': 'mk-mk',
    'tr': 'tr-tr',
    'bg': 'bg-bg',
    'hr': 'rs-rs',
    'au': 'au-au',
}
export const mapLangToLocale = (key) => {
    if (langMap[key]) {
        return langMap[key];
    }

    return 'en-us';
}

export const currentLanguage = () => {
    return document.documentElement.lang
}

export const currentLocale = () => {
    return mapLangToLocale(currentLanguage());
}
